import React, { PropsWithChildren, useMemo } from "react";
export interface ILocalizationContext {
  locale: string;
  dateFormat: string;
  timeFormat: string;
  decimalSeparator: string;
  thousandSeparator: string;
  decimalRounding: number;
  decimalSpaces: number;
  currencyCode: string;
  t: (...args) => string;
}

const defaultParams = {
  locale: "en-US",
  dateFormat: "MMM D. YYYY",
  timeFormat: "HH:mm a",
  decimalSeparator: ".",
  thousandSeparator: ",",
  decimalRounding: 0,
  decimalSpaces: 2,
  currencyCode: "USD",
  t: (value: string) => value,
};
export const LocalizationContext =
  React.createContext<ILocalizationContext>(defaultParams);

interface Props {
  params: Partial<ILocalizationContext>;
  translator?: (string, props: Record<string, string | number>) => string;
}
export const LocalizationProvider: React.FC<PropsWithChildren<Props>> = ({
  children,
  params,
}) => {
  const value = useMemo(() => {
    return {
      ...defaultParams,
      ...params,
    };
  }, [params]);
  return (
    <LocalizationContext.Provider value={value}>
      {children}
    </LocalizationContext.Provider>
  );
};

export const useLocalization = () => React.useContext(LocalizationContext);
